<template>
  <div>
    <el-card v-if="companyApplyListShow == 0 ">
      <template #header>
        <span>已注册公司</span>
      </template>
      <div class="content">
        <div class="button-group-title">
          <el-button type="primary" @click="companyApplyListShow = 1" :plain="true">
            <i class="el-icon-circle-plus"></i>
            新注册公司
          </el-button>
        </div>
        <div style="margin-top: 10px;">
          <el-table :data="itemCompanyList" style="width: 100%;text-align: center; height: 100%; " border ref="refTable"
                    :header-cell-style="{ background: '#3e70c7', color: '#333' }">
            <el-table-column prop="id" label="id" width="80" show-overflow-tooltip align="center"/>
            <el-table-column prop="companyName" label="公司名称" min-width="110" show-overflow-tooltip align="center"/>
            <el-table-column label="公司审核状态" min-width="110" show-overflow-tooltip align="center">
              <template slot-scope="scope">
                <div class="info-content" v-if="scope.row.state == 0">审核中</div>
                <div class="info-content" v-if="scope.row.state == 1">审核通过</div>
                <div class="info-content" v-if="scope.row.state == 2">审核未通过</div>
                <div class="info-content" v-if="scope.row.state == 3">正式运行中</div>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" min-width="110" show-overflow-tooltip align="center"/>
          </el-table>
        </div>
      </div>
    </el-card>
    <RegisterCompany v-if="companyApplyListShow == 1" @returnBack="returnBack"></RegisterCompany>
  </div>
</template>

<script>
import API from "../../../../../config/api";
import IMGURL from "../../../../../config/imgUrl"
import RegisterCompany from "@/pages/userCenter/ChildComps/RegisterCompany"

export default {
  components: {
    RegisterCompany
  },
  data() {
    return {
      itemCompanyList: [
        // 	{
        // 	businessLicense: "/uploadImg/2022-03/92_20220321_084720_营业执照副本_min.jpg",
        // 	companyName: "山东盟润亨智能科技有限公司",
        // 	createTime: "2022-03-21 08:47:31",
        // 	id: 118,
        // 	totalVariables: 50
        // },
      ],
      companyId: '',
      userId: '',
      logoImg: IMGURL.logoImgUrl, //logo图片
      logoCompany: IMGURL.logoCompany,
      companyApplyListShow:0,

    }
  },
  mounted() {
    // 获取该用户注册的所有公司
    this.userId = window.localStorage.getItem('userid');
    console.log('公司列表userId的值=', this.userId);
    this.getCompanyApplyList();
  },
  methods: {
    //从注册公司页面返回此页面
    returnBack(){
      this.getCompanyApplyList();
      this.companyApplyListShow = 0;
    },
    getCompanyApplyList() {  //获取已注册公司信息
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {
        adminId: window.localStorage.getItem('userid'),
      }
      this.$axiosRequest({
        url: API.getCompanyApplyList,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          console.log(res);
          this.itemCompanyList = res.data["companyApplyList"];
        }
      });
    },
  },
}
</script>

<style lang="less">
swiper {
  height: 400px;

  image {
    width: 100%;
  }
}

.info-title {
  font-size: 18px;
  font-weight: bold;
  color: #004768;
  font-family: '仿宋';
}

.info-content {
  font-size: 18px;
  font-family: '仿宋';
  // font-weight: bold;
}

.info-card {
  margin: 10px 15px 10px 15px; // 上 右 下 左
  padding: 24px;
  background-color: rgba(240, 240, 240, 0.7);
}

.info-content {
  margin: 10px 0px 10px 10px; // 上 右 下 左
  height: auto;
}

.title-style {
  font-size: 18px;
  font-weight: bold;
}

.title2-style {
  font-size: 15px;
  //font-weight: bold;
  line-height: 40px;
}

.title3-style {
  font-size: 12px;
  line-height: 40px;
  color: gray
}

.button-group-card {
  margin: 10px 15px 10px 15px; // 上 右 下 左
  background-color: rgba(240, 240, 240, 0.5);
  padding: 12px;
}

.button-group-title {
  margin: 10px 15px 10px 15px; // 上 右 下 左
  font-size: 18px;
  font-weight: bold;
}
</style>

